// Статусы задач
export const TASK_STATUS = {
  TODO: 'todo',
  IN_PROGRESS: 'in_progress',
  REVIEW: 'review',
  DONE: 'done',
  ARCHIVED: 'archived'
};

// Категории задач
export const TASK_CATEGORIES = {
  ITEMS1: 'items1', // To Do
  ITEMS2: 'items2', // In Progress
  ITEMS3: 'items3', // Done
  ITEMS4: 'items4'  // Review
};

// Приоритеты задач
export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
};

// Статусы загрузки
export const LOADING_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Типы уведомлений
export const NOTIFICATION_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
}; 